// ─── Shared payment-error match rules ────────────────────────────────────────
// The backend re-checks Chargebee (source of truth) before creating a
// subscription and, when a live subscription already exists, throws HTTP 409
// { detail: { error_code: "already_subscribed" } } from BOTH get-checkout-url
// and process-card-payment. This is NOT a payment failure and must NOT be
// conflated with the normal 200 { status: "failed" } Chargebee decline.
//
// The rule lives here — dependency-free and shape-agnostic — so the several
// call sites that each see the error in a different wrapper (raw axios error vs.
// the { error: axiosError } payload that rejectWithValue produces) all decide
// "already subscribed" the same way. Callers normalize their own error shape
// down to `detail` before calling. Keeping one rule means the checkout-open and
// checkout-submit flows can never silently disagree on what already_subscribed
// means. (Requested by Backend team, 2026-07-07 — signup double-charge fix;
// centralized per PR #1395 review, 2026-07-07.)
export const isAlreadySubscribedDetail = (detail: unknown): boolean => {
  if (typeof detail === "object" && detail !== null) {
    return (detail as { error_code?: string }).error_code === "already_subscribed";
  }
  if (typeof detail === "string") {
    return detail.toLowerCase().includes("user is already subscribed");
  }
  return false;
};
